export interface PermisoDTO{
    idproyecto: number,
    mensaje: string,
    bandera: boolean,
}

export function VoidPermisoDTO(){
    return{
        idproyecto: 0,
        mensaje: '',
        bandera: false,
    }    
}